import _ from 'lodash';
import { I18nPluralPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges, AfterViewInit, Output, EventEmitter, ViewChild, HostListener, inject, DestroyRef } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { of, timer } from 'rxjs';
import { first, mergeMap } from 'rxjs/operators';
import { selectUserData } from 'app/core/features/user/user.selectors';
import { DeleteChatMessage, UnblockChatAttendee } from '../../features/chat.actions';
import { MdbPopoverDirective } from 'mdb-angular-ui-kit/popover';
import { PopoverService } from 'app/core/services/popover.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

let id = 1;

@Component({
  selector: 'app-chat-message',
  templateUrl: './chat-message.component.html',
  styleUrls: ['./chat-message.component.scss'],
  providers: [I18nPluralPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatMessageComponent implements OnChanges, OnInit, AfterViewInit {
  destroyRef = inject(DestroyRef)
  @ViewChild('popover') popover: MdbPopoverDirective = null;
  
  @Input() virtualEventData = null;
  @Input() message = null;
  @Input() index: number = 0;
  @Input() styles = {
    width: '310px'
  };

  @Output() onAfterViewInit: EventEmitter<any> = new EventEmitter();

  private _id = id++;
  get id() {
    return `SharedLinkCampaignPopover_${this._id}`;
  }

  public user$ = this.store.pipe(select(selectUserData));
  public timestamp: number = null;
  public classes = []

  public timer$ = timer(1000, 5000).pipe(
    mergeMap(this.getTimerValue.bind(this))
  );
  
  constructor(
    public store: Store,
    private popoverService: PopoverService,
  ) { }

  ngOnInit(): void {
    this.timestamp = this.message.messageTime;
  }

  ngOnChanges(changes: SimpleChanges) {
    const message = _.get(changes, 'message.currentValue', this.message);
    const classes = [];

    const status = _.get(message, 'messageStatus', 0);
    switch(status) {
      case 0:
        classes.push('chat-message--regular');
        break;
      case 1:
        classes.push('chat-message--blocked');
        break;
      case 2:
        classes.push('chat-message--admin');
        break;
    }

    const deleted = _.get(message, 'deleted', false);
    if(deleted) {
      classes.push('chat-message--deleted');
    }

    this.classes = classes;
  }

  ngAfterViewInit(): void {
    this.store.pipe(
      select(selectUserData),
      first(),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(user => {
      this.onAfterViewInit.next({
        index: this.index,
        scrollToBottom: _.isEqual(user.id, this.message.donor.id)
      });
    });
  }

  onPopoverShown(): void {
    this.popoverService.list[this.id] = this.popover;
  }

  onPopoverHidden(): void {
    delete this.popoverService.list[this.id];
  }

  getTimerValue() {
    let result = Math.round(new Date().getTime()/1000) - this.timestamp;
    return of(result);
  }

  getName(user) {
    if(user.id === this.message.donor.id) {
      return 'You';
    } else if(this.message.donor.id === this.virtualEventData.owner) {
      return 'Admin';
    } else {
      return this.message.donor.name;
    }
  }

  onDeleteChatMessage(id, blockUser) {
    this.store.dispatch({
      type: DeleteChatMessage.type,
      payload: { id, blockUser }
    });
  }

  onUnblockChatAttendee(id) {
    this.store.dispatch({
      type: UnblockChatAttendee.type,
      payload: { id }
    });
  }

  getUserColor(user) {
    if(user.id === this.message.donor.id) {
      return 'var(--chat-bubble-color)';
    } else if(this.message.donor.id === this.virtualEventData.owner) {
      return 'var(--chat-bubble-color)';
    } else if(this.message.messageStatus === 1) {
      return '#D0021B';
    } else if(this.message.deleted) {
      return '#D0021B';
    } else {
      return window['getSenderColor'](parseInt("0x" + this.message.donor.id.slice(-2)));
    }
  }

  getMessageDescription() {
    if(this.message.deleted) {
      return 'Deleted';
    } else if(this.message.messageStatus === 1) {
      return 'User Blocked';
    }
    return '';
  }

  togglePopover(popover) {
    const { message } = this;
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open({ message });
    }
  }
  
  showActions() {
    const { message } = this;
    if(message.messageStatus === 2) {
      return !message.deleted;
    }
    return true;
  }

}
